import type { DepositBreakdown } from '@/types/booking';

export type DepositMockMode = 'refundable' | 'nonRefundable';

export const DEPOSIT_MOCK_PERCENT = 25;
export const DEPOSIT_MOCK_FEE_CENTS = 150;

export const parseDepositMockMode = (
  value: string | undefined,
): DepositMockMode | null =>
  value === 'refundable' || value === 'nonRefundable' ? value : null;

export const buildMockDeposit = (
  breakdownPrice: number | undefined,
  mode: DepositMockMode,
): DepositBreakdown | null => {
  if (!breakdownPrice) return null;

  const amount = Math.round((breakdownPrice * DEPOSIT_MOCK_PERCENT) / 100);
  if (amount <= 0) return null;

  return {
    amount,
    feeAmount: DEPOSIT_MOCK_FEE_CENTS,
    total: amount + DEPOSIT_MOCK_FEE_CENTS,
    refundable: mode === 'refundable',
    lines: [],
  };
};
